import type { Messages } from '../de';

export default {
  title: 'Maps',
  kicker: {
    one: '{count} GPS activity · {dist} · start points hidden',
    other: '{count} GPS activities · {dist} · start points hidden',
  },
  year: 'Year',
  all: 'All',
  routesFailed: 'Routes not loaded: {error}',
  tilesFailed: 'Tiles not loaded: {error}',
  explorerAria: 'Explorer tiles',
  tilesLoading: 'Calculating tiles …',
  heatmapAria: 'Route heatmap',
  routesLoading: 'Loading routes …',
  perSport: 'By sport',
  privacy:
    'A circle of {m} m is cut out around the start and end of every route – also where the route passes by again later. So no address can be read from the overlay. Tap a line to open the activity.',
  layer: { aria: 'Map layer', routes: 'Routes', tiles: 'Tiles' },
  tiles: {
    title: 'Explorer tiles',
    count: { one: '{count} tile', other: '{count} tiles' },
    square: 'Max square',
    cluster: 'Max cluster',
    newIn: 'New in {month}',
    histAria: 'New tiles per month, last 12 months: {list}',
    visited: 'visited',
    newInLegend: 'new in {month}',
    squareLegend: 'Square',
    privacy:
      'Tiles (zoom {zoom}, just over 1 km wide) from {count} activities with a full GPS track. Tiles a route only touches within {radius} m of its start or end count, but are not shown. How often you visited a tile is not shown anywhere.',
  },
  mapAria: {
    route: 'Map with the route of this activity',
    heat: 'Map with {count} overlaid routes',
    tiles: 'Map with {count} visited tiles',
  },
} satisfies Messages['maps'];
